/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import Group from 'material/group/group';
import Icon from 'material/graphic/icon/icon';
import DatePicker from 'material/datepicker/datepicker';
//CTAs
import CTAs from "material/ctas/ctas";
import Button from "material/ctas/button/button_container";
import Link from "material/ctas/link/link";
// utils
import zeroPadding from 'utils/zeroPadding';
import getLastTwoDigit from 'utils/getLastTwoDigit';
import { isAfterFourPM } from 'utils/isafterfourpm';
// styles
import injectSheet from 'react-jss';
import styles from 'material/dropdowns/daterangepickerdropdown/daterangepickerdropdown_styles';



/* ========== ~~~~~~~~~~ DROP FILTER : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Daterangepickerdropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false,
            indicator: props.hideButtons ? this.changeDateFormat(props.range.from) + ' - ' + this.changeDateFormat(props.range.to): 'Last 7 days',
        };
    }

    componentDidMount() {
        return document.addEventListener('mousedown', this.handleOutsideClick, false);
    }
    componentWillUnmount() {
        return document.removeEventListener('mousedown', this.handleOutsideClick, false);
    }
    handleOutsideClick = (e) =>{
        // ignore clicks on the component itself
        if (!this.node.contains(e.target) && this.state.active) {
            this.hideMenu()
        }
    };
    changeDateFormat = (iso) => {
        const date = new Date(`${iso}T00:00:00-05:00`);
        return `${zeroPadding((date.getMonth() + 1), 2)}/${zeroPadding(date.getDate(), 2)}/${getLastTwoDigit(date.getFullYear())}`
    };
    rangeFormat = (range) =>{
        const {to, from} = range;
        return (!to || !from) ?  this.props.range : ({ from:`${from.getFullYear()}-${zeroPadding((from.getMonth() + 1), 2)}-${zeroPadding(from.getDate(), 2)}`,
            to:`${to.getFullYear()}-${zeroPadding((to.getMonth() + 1), 2)}-${zeroPadding(to.getDate(), 2)}` });
    };
    handleRangeSelect = (range) =>{
        this.setState({indicator: null});
        let rangeFormat = this.rangeFormat(range);
        this.props.updateRange(rangeFormat);
    };
    showMenu = () => this.setState({ active: true });
    hideMenu = () =>{
        let rangeFormat = this.rangeFormat({
            from: new Date(`${this.props.range.from}T00:00:00-05:00`),
            to: new Date(`${this.props.range.to}T00:00:00-05:00`)
        });
        this.setState({ active: false });
        this.props.updateRange(rangeFormat);
    };
    handleClick = () => this.state.active ? this.hideMenu() : this.showMenu();
    renderRange = () => {
        const to = new Date(`${this.props.range.to}T00:00:00-05:00`);
        const from = new Date(`${this.props.range.from}T00:00:00-05:00`);
        return this.state.indicator ? `${this.state.indicator}` : to ? `${zeroPadding((from.getMonth() + 1), 2)}/${zeroPadding(from.getDate(), 2)}/${getLastTwoDigit(from.getFullYear())} - ${zeroPadding((to.getMonth() + 1), 2)}/${zeroPadding(to.getDate(), 2)}/${getLastTwoDigit(to.getFullYear())}` : `Select dates`;
    };
    handleButtonClick = (rangeLength) =>{
        let range = {
            from: new Date(new Date() - 1000 * 60 * 60 * 24 * rangeLength),
            to: new Date(new Date() - (isAfterFourPM() ? (1000 * 60 * 60 * 24) : (1000 * 60 * 60 * 24 * 2)))
        };
        let rangeFormat = this.rangeFormat(range);
        this.props.updateRange(rangeFormat);
        this.setState({indicator: `Last ${rangeLength} days`});
    };
    handleApply = () =>{
        this.props.handleApply && this.props.handleApply();
        this.hideMenu()
    };

    handleClear = () =>{
        this.setState({indicator: null})
    };
    render() {
        let { active } = this.state;
        return (
            <div className={`daterangepickerdropdown ${this.props.classes.daterangepickerdropdown} filter`} ref={node => {this.node=node;}}>
                <div className={`placeholder active-${active}`} onClick={this.handleClick}><span>{this.renderRange()}</span><Icon name={`sort-down`}/></div>
                <Group name={`dropdown active-${active}`}>
                    <CTAs name={`date-ranges hide-${this.props.hideDateRangeHelpers?'true':'false'}`}>
                        <Button handleClick={()=>this.handleButtonClick(7)} text={`Last 7 days`} variant={`normal`}/>
                        <Button handleClick={()=>this.handleButtonClick(30)} text={`Last 30 days`} variant={`normal`}/>
                        <Button handleClick={()=>this.handleButtonClick(90)} text={`Last 90 days`} variant={`normal`}/>
                        <Button handleClick={()=>this.handleButtonClick(180)} text={`Last 180 days`} variant={`normal`}/>
                    </CTAs>
                    <DatePicker range={{
                        from: new Date(`${this.props.range.from}T00:00:00-05:00`),
                        to: new Date(`${this.props.range.to}T00:00:00-05:00`)
                    }} handleRangeSelect={this.handleRangeSelect} disabledDays={this.props.disabledDays} numberOfMonths={2}/>
                    <CTAs name={`clear-apply hide-${this.props.hideButtons?'true':'false'}`}>
                        <Link type={`action`} action={this.handleClear} color={`primary`} text={`Clear`}/>
                        {this.props.range.to && <Link type={`action`} action={this.handleApply} color={`primary`} text={`Apply`}/>}
                    </CTAs>
                </Group>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Daterangepickerdropdown);
